import Moment from 'moment';
import { toUniversalUtcDate } from '../../utils/date.utils';
import { getRegionByProduct } from '../../i18n/utils';
import { languages } from '../../i18n/i18n.language-config';

const CURRENCY_BY_LANGUAGE = {
  [languages['en-US']]: 'USD',
  [languages['en-GB']]: 'GBP',
  [languages['en-AU']]: 'AUD',
} as const;

export const formatQuotes = ({ data }: any) => {
  return data.map((quote: any) => formatQuote(quote));
};

export const formatPrimeXQuote = (payload: any) => {
  const rawQuote = payload?.quote ?? payload;
  const language = getRegionByProduct(rawQuote.product);

  return formatQuote({
    ...rawQuote,
    customerStatus: rawQuote.customerStatus ?? rawQuote.agencyStatus,
    currency: rawQuote.currency ?? CURRENCY_BY_LANGUAGE[language],
    limit: rawQuote.limit ?? rawQuote.aggLimit,
    totalPremium:
      rawQuote.totalPremium ??
      rawQuote.premium ??
      rawQuote.raterResponse?.totalPremium,
  });
};

export const formatQuote = (quote: any) => {
  return {
    ...quote,
    uiEffectiveDate: toUniversalUtcDate(quote.effectiveDate, {
      placeholder: null,
    }),
    uiPolicyExpiresOn: toUniversalUtcDate(quote.endDate, {
      placeholder: null,
    }),
    uiExpiresOn: toUniversalUtcDate(quote.expiresOn, {
      placeholder: null,
    }),
    uiAgentFullName:
      quote.agentFirstName && quote.agentLastName
        ? `${quote.agentFirstName} ${quote.agentLastName}`
        : null,
    uiAgentInitials:
      quote.agentFirstName && quote.agentLastName
        ? `${quote.agentFirstName[0]}${quote.agentLastName[0]}`
        : null,
    uiTerm:
      quote.effectiveDate && quote.expiresOn
        ? Moment.utc(quote.endDate).diff(
            Moment.utc(quote.effectiveDate),
            'days'
          )
        : null,
    uiIsEndorsement: quote.isEndorsement ? 'Yes' : 'No',
  };
};
